import { useEffect, useState } from 'react';

// dealers with own price per product (this device); report rows store the chosen dealer
const KEY = 'giss_dealers';
const ev = () => window.dispatchEvent(new Event('giss-dealers'));
export const getDealers = () => { try { return { list: [], prices: {}, ...JSON.parse(localStorage.getItem(KEY)) }; } catch { return { list: [], prices: {} }; } };
const save = (d) => { localStorage.setItem(KEY, JSON.stringify(d)); ev(); };

export function useDealers() {
  const [d, setD] = useState(getDealers);
  useEffect(() => { const on = () => setD(getDealers()); window.addEventListener('giss-dealers', on); return () => window.removeEventListener('giss-dealers', on); }, []);
  return d;
}
export const addDealer = (x) => { const d = getDealers(); d.list.push({ id: `dl${Date.now().toString(36)}`, name: x.name.trim(), email: (x.email || '').trim(), phone: (x.phone || '').trim() }); save(d); };
export const delDealer = (id) => { const d = getDealers(); d.list = d.list.filter((x) => x.id !== id); Object.values(d.prices).forEach((p) => delete p[id]); save(d); };
export const itemKey = (m) => (m.mfrId ? `${m.mfrId}:${m.ref}` : m.ref ? `cat:${m.ref}` : `own:${m.name}|${m.dim || ''}`);
export const dealerPrice = (d, key, id) => d.prices[key]?.[id] ?? null;
export const setDealerPrice = (key, id, price) => { const d = getDealers(); d.prices[key] = { ...d.prices[key], [id]: price }; save(d); };
